import {BaseFormModel} from './base-form-model';
import {OrganizationRole} from './organization-role';
import {MenuItemPriceSummary} from './menu-item-price-summary';
import {MembershipProgram} from './membership-program';
import {TabNoteDefinition} from './tab-note-definition';
import {OrganizationEvent} from './organization-event';

export class CompDefinition extends BaseFormModel<CompDefinition> {
    id: number;
    orgId: number;
    name: string;
    description: string;
    type: string;
    availability: string;
    color: string;
    contrastColor: string;
    amount: number;
    max: number;
    autoApply: boolean;
    requiredCount: number;
    rewardCount: number;
    birthday: boolean;
    birthdayDuration: string;
    priority: string;
    limitDurationPart: string;
    limitDurationCount: number;
    limitCount: number;
    visitCount: number;
    combinedCount: number;
    roles: OrganizationRole[];
    membershipPrograms: MembershipProgram[];
    organizationEvents: OrganizationEvent[];
    items: MenuItemPriceSummary[];
    conditionItems: MenuItemPriceSummary[];
    membershipProgram: MembershipProgram;
    selected: boolean;
    requiredTabNote: TabNoteDefinition;
    sortOrder: number;
    deleted: boolean;
}
